import { api } from "../api";
import { SpecialCategory } from "./types";

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSpecialCategories: builder.query<SpecialCategory[], void>({
      query: () => ({
        url: "/special-category",
        method: "GET",
      }),
      providesTags: ["SpecialCategories"],
    }),
    createSpecialCategory: builder.mutation<SpecialCategory, { name: string }>({
      query: (body) => ({
        url: "/special-category",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SpecialCategories"],
    }),
    deleteSpecialCategory: builder.mutation<void, number>({
      query: (id) => ({
        url: `/special-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SpecialCategories"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSpecialCategoriesQuery,
  useCreateSpecialCategoryMutation,
  useDeleteSpecialCategoryMutation,
} = extendedApi;
